module.exports = __webpack_public_path__ + "static/media/content_hero.9b1f808f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/brite/content_hero.png
// module id = 279
// module chunks = 0